import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import useSearchFilter from "hooks/useSearchFilter"
import { getCalendarBookings } from "store/calendar"
import { useCalendarDateRange } from "./useCalendarDateRange"
import { buildBookingsParams } from "./utils"

export function useRefreshCalendarBookings() {
  const dispatch = useDispatch()
  const [params] = useSearchFilter({ accessAttributes: ["range", "date", "tab"] })
  const dates = useCalendarDateRange(params)
  const savedFilters = useSelector((state) => state.calendar?.savedFilters)

  return useCallback(() => {
    if (!dates?.start || !dates?.end || !params.range || !params.tab || !savedFilters) return
    dispatch(getCalendarBookings(buildBookingsParams(params, dates, savedFilters)))
  }, [dates?.start, dates?.end, params.range, params.tab, savedFilters, dispatch])
}
